import {
  Dialog,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Stack,
} from '@mui/material';
import { FC } from 'react';

interface ILoadingDialogProps {
  message: string;
}

export const LoadingDialog: FC<ILoadingDialogProps> = (props) => {
  return (
    <Dialog open={props.message.length > 0} maxWidth="sm" fullWidth>
      <DialogContent>
        <Stack spacing={2} direction={'column'}>
          <DialogContentText align={'center'}>
            {props.message}
          </DialogContentText>

          <LinearProgress />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
